import React from "react"
import { motion } from "framer-motion"
import { Loader2, LucideIcon } from "lucide-react"

interface ButtonProps {
  title: string
  disabled?: boolean
  isLoading?: boolean
  theme?: "primary" | "secondary" | "outline" | "danger"
  type?: "button" | "submit" | "reset"
  onClick?: () => void
  icon?: LucideIcon
  iconPosition?: "left" | "right"
  className?: string
}

const Button2 = ({
  title,
  disabled = false,
  isLoading = false,
  type = "button",
  className,
  onClick,
  icon: Icon,
  iconPosition = "left",
  theme = "primary"
}: ButtonProps) => {
  return (
    <motion.button
      whileHover={!disabled && !isLoading ? { scale: 1.02 } : {}}
      whileTap={!disabled && !isLoading ? { scale: 0.98 } : {}}
      className={`
        inline-flex items-center justify-center gap-2 px-4 py-2 
        rounded-md font-medium transition-colors
        ${theme === "primary" ? 
          'bg-[#0c1d46] text-white hover:bg-blue-600 active:bg-blue-700' :
          theme === "secondary" ? 
          'bg-blue-500 text-gray-400 cursor-not-allowed' :
          theme === "outline" ? 
          'bg-transparent border border-gray-300 text-gray-400 hover:bg-gray-100 active:bg-gray-200' :
          theme === "danger" ? 
          'bg-red-500 text-white hover:bg-red-600 active:bg-red-700' :
          ''
        }
        ${disabled ? 
          'bg-gray-100 text-gray-400 cursor-not-allowed' : 
          'bg-blue-500 text-white hover:bg-blue-600 active:bg-blue-700'
        }
        ${className}
      `}
      disabled={disabled || isLoading}
      type={type}
      onClick={onClick}
    >
      {isLoading ? (
        <Loader2 className="w-4 h-4 animate-spin" />
      ) : (
        <>
          {Icon && iconPosition === "left" && <Icon className="w-4 h-4" />}
          <span>{title}</span>
          {Icon && iconPosition === "right" && <Icon className="w-4 h-4" />}
        </>
      )}
    </motion.button>
  )
}

export default Button2